import { render, staticRenderFns } from "./topSec.vue?vue&type=template&id=8b9296a4&scoped=true"
import script from "./topSec.vue?vue&type=script&lang=js"
export * from "./topSec.vue?vue&type=script&lang=js"
import style0 from "./topSec.vue?vue&type=style&index=0&id=8b9296a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9296a4",
  null
  
)

export default component.exports